import {APIURL} from '../../constants';
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        isFetching: false,
        months: {
            "1": "January",
            "2": "February",
            "3": "March",
            "4": "April",
            "5": "May",
            "6": "June",
            "7": "July",
            "8": "August",
            "9": "September",
            "10": "October",
            "11": "November",
            "12": "December"
        },
        stats: {}
    },
    actions: {
        index(context, payload)
        {
            let year = (new Date()).getFullYear();
            if(typeof payload !== 'undefined') { year = payload; }
            let url = `${APIURL}stats?year=${year}`; 
            context.commit('setIsFetching', true);

           

            axios.get(url)
            .then((res) => {


                context.dispatch('mergeCounters', res.data);
            }) 

        },

        mergeCounters(context, payload)
        {
            let ecoCounters = payload.ecoCounters;
            let statsCount = payload.statsCount;
            let ecoKeys = Object.keys(ecoCounters);
            let statsKeys = Object.keys(statsCount);
            let stats = {}

            ecoKeys.forEach((k) => {
                stats[k] = {};

                Object.keys(ecoCounters[k]).forEach((m) => {
                    stats[k][m] = {
                        eco: ecoCounters[k][m]
                    };

                })
            })

            statsKeys.forEach((k) => {
                if(typeof stats[k] === 'undefined')
                {
                    stats[k] = {}
                }

                Object.keys(statsCount[k]).forEach((m) => {
                    if(typeof stats[k][m] === 'undefined')
                    {
                        stats[k][m] = {
                            stats: statsCount[k][m]
                        }
                    } else {
                        stats[k][m].stats = statsCount[k][m]
                    }

                })
            })

            context.commit('setStats', stats)
            context.commit('setIsFetching', false)




        }
    },
    mutations: {
        setIsFetching(state, payload)
        {
            state.isFetching = payload;
        },

        setStats(state, payload)
        {
            state.stats = payload
        }


    },
    getters: {
        isFetching(state)
        {
            return state.isFetching;
        },

        months(state)
        {
            return state.months;
        },

        stats(state)
        {
            return state.stats;
        }
    }
}